var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#85a2b6",
    x: 14.5,
    y: 14.5,
    width: 32,
    height: 32,
    rx: 4,
    ry: 4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "1.3888888888888888s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "14.5;53.5;53.5;53.5;53.5;14.5;14.5;14.5;14.5",
    begin: "-1.2731481481481481s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.3888888888888888s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "14.5;53.5;53.5;53.5;53.5;14.5;14.5;14.5;14.5",
    begin: "-0.9259259259259259s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#bbcedd",
    x: 14.5,
    y: 14.5,
    width: 32,
    height: 32,
    rx: 4,
    ry: 4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "1.3888888888888888s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "14.5;53.5;53.5;53.5;53.5;14.5;14.5;14.5;14.5",
    begin: "-0.8101851851851852s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.3888888888888888s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "14.5;53.5;53.5;53.5;53.5;14.5;14.5;14.5;14.5",
    begin: "-0.46296296296296297s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dce4eb",
    x: 14.5,
    y: 14.5,
    width: 32,
    height: 32,
    rx: 4,
    ry: 4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "1.3888888888888888s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "14.5;53.5;53.5;53.5;53.5;14.5;14.5;14.5;14.5",
    begin: "-0.3472222222222222s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "1.3888888888888888s",
    repeatCount: "indefinite",
    keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
    values: "14.5;53.5;53.5;53.5;53.5;14.5;14.5;14.5;14.5",
    begin: "0s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.abf39833645a4a52ae0e682dac2247a6.svg";
export { ForwardRef as ReactComponent };